var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { attrs: { id: "search-com" } },
    [
      _c("h3", [
        _vm.type !== "user" ? _c("span", [_vm._v("数据筛选")]) : _vm._e(),
        _vm._v(" "),
      ]),
      _c(
        "el-form",
        {
          ref: "searchForm",
          staticClass: "search-form",
          attrs: { inline: true, model: _vm.searchForm, size: "small" },
        },
        [
          _vm.isShowCom.channel
            ? _c(
                "el-form-item",
                { attrs: { label: "入线渠道", prop: "channel" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        placeholder: "请选择入线渠道",
                        filterable: "",
                        clearable: "",
                      },
                      on: { change: _vm.onChangeChannel },
                      model: {
                        value: _vm.searchForm.channel,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "channel", $$v)
                        },
                        expression: "searchForm.channel",
                      },
                    },
                    _vm._l(_vm.channelList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.name, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isShowCom.orgCode
            ? _c(
                "el-form-item",
                { attrs: { label: "公司部门", prop: "orgCode" } },
                [
                  _c("el-cascader", {
                    attrs: {
                      options: _vm.orgCodeList,
                      props: {
                        label: "orgName",
                        value: "orgCode",
                        children: "children",
                        multiple: true,
                        checkStrictly: true,
                      },
                      placeholder: "请选择公司部门",
                      "show-all-levels": false,
                      "collapse-tags": "",
                      clearable: "",
                    },
                    on: { change: _vm.onChangeOrgCode },
                    model: {
                      value: _vm.searchForm.orgCode,
                      callback: function ($$v) {
                        _vm.$set(_vm.searchForm, "orgCode", $$v)
                      },
                      expression: "searchForm.orgCode",
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm.isShowCom.staff
            ? _c(
                "el-form-item",
                { attrs: { label: "员工", prop: "staffCode" } },
                [
                  _c(
                    "el-select",
                    {
                      attrs: {
                        disabled: _vm.staffList.length === 0,
                        placeholder: "请选择员工",
                        filterable: "",
                        clearable: "",
                      },
                      on: { change: _vm.onChangeStaff },
                      model: {
                        value: _vm.searchForm.staffCode,
                        callback: function ($$v) {
                          _vm.$set(_vm.searchForm, "staffCode", $$v)
                        },
                        expression: "searchForm.staffCode",
                      },
                    },
                    _vm._l(_vm.staffList, function (item) {
                      return _c("el-option", {
                        key: item.id,
                        attrs: { label: item.reallyName, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
          _vm.isShowCom.searchBut
            ? _c(
                "el-form-item",
                { staticClass: "search-but" },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData(false)
                        },
                      },
                    },
                    [_vm._v("查询")]
                  ),
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary", plain: "" },
                      on: {
                        click: function ($event) {
                          return _vm.fetchData(true)
                        },
                      },
                    },
                    [_vm._v("重置 ")]
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.isShowCom.date
        ? _c(
            "div",
            { staticClass: "search-date" },
            [
              _vm._l(_vm.searchDateList, function (item, index) {
                return [
                  item.isUse
                    ? _c(
                        "el-button",
                        {
                          key: index,
                          attrs: {
                            size: "small",
                            type:
                              _vm.currentChooseDate == item.value
                                ? "primary"
                                : "info",
                            plain: "",
                          },
                          on: {
                            click: function ($event) {
                              return _vm.onChangeDate(item.value)
                            },
                          },
                        },
                        [_vm._v(_vm._s(item.name) + " ")]
                      )
                    : _vm._e(),
                ]
              }),
              _c("transition", { attrs: { name: "diy-time" } }, [
                _vm.currentChooseDate === 10000
                  ? _c(
                      "div",
                      { staticClass: "diy-time" },
                      [
                        _vm._v(" 选择时间 "),
                        _c("el-date-picker", {
                          attrs: {
                            type: "daterange",
                            align: "right",
                            size: "small",
                            "unlink-panels": "",
                            "range-separator": "至",
                            "start-placeholder": "开始日期",
                            "end-placeholder": "结束日期",
                            format: "yyyy-MM-dd",
                            "value-format": "yyyy-MM-dd",
                          },
                          on: { change: _vm.onChangeTime },
                          model: {
                            value: _vm.searchForm.diyTime,
                            callback: function ($$v) {
                              _vm.$set(_vm.searchForm, "diyTime", $$v)
                            },
                            expression: "searchForm.diyTime",
                          },
                        }),
                      ],
                      1
                    )
                  : _vm._e(),
              ]),
            ],
            2
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }